import { ILayoutState } from './interfaces';

const state: ILayoutState = {
    value: {
        collapsed: false,
        theme: 'dark',
        reuseTab: true,
        isPad: false,
    },
};

const mutations = {
    set(state: ILayoutState, val: ILayoutState['value']) {
        state.value = val;
    },
};

const getters = {
    get: (state: ILayoutState) => state.value,
};

const layoutStore = {
    namespaced: true,
    state,
    getters,
    mutations,
};

export default layoutStore;
